import React from 'react';
import { Box, Typography } from '@mui/material';
import { Palette } from '@/themes/themeOverrides/Palette';

const UptimeStatsContent = ({ transactionStats }) => (
    <>
        <Typography variant='h3' sx={{ fontWeight: 700, marginBottom: '26px' }}>
            {typeof transactionStats?.uptime === 'number' ? `${Math.round(transactionStats.uptime * 100)}%` : '-'}
        </Typography>
        <Box
            sx={{
                backgroundColor: Palette.gray.gray75,
                borderRadius: '8px',
                padding: '8px',
                display: 'flex',
                gap: '2px',
                outline: `2px solid ${Palette.gray.gray100}`,
                outlineOffset: '-2px',
            }}
        >
            {Array.from({ length: 10 }).map((_, i) => {
                const uptime = typeof transactionStats?.uptime === 'number' ? transactionStats.uptime * 100 : 0;
                const filledSegments = Math.round(uptime / 10);
                let color = Palette.gray.gray200;
                if (i < filledSegments) {
                    if (uptime <= 25) color = Palette.red.red500;
                    else if (uptime <= 50) color = Palette.yellow.yellow500;
                    else color = Palette.green.green500;
                }
                return (
                    <Box
                        key={i}
                        sx={{
                            flex: 1,
                            height: '24px',
                            borderRadius: '4px',
                            backgroundColor: color,
                            transition: 'background 0.2s',
                        }}
                    />
                );
            })}
        </Box>
    </>
);

export default UptimeStatsContent;
